<main class="registration-container">
  <section class="registration-card" aria-labelledby="registration-title">
    <div class="registration-header">
      <p class="eyebrow">DHE Scholarships</p>
      <h1 id="registration-title">Create your applicant account</h1>
      <p>Register once, then complete each scholarship application using its own template.</p>
    </div>

    <app-social-login-buttons mode="register"></app-social-login-buttons>

    <form [formGroup]="registrationForm" (ngSubmit)="submit()" novalidate>
      <div class="form-row">
        <div class="form-group">
          <label for="firstName">First name *</label>
          <input id="firstName" class="form-control" formControlName="firstName" autocomplete="given-name" />
        </div>
        <div class="form-group">
          <label for="lastName">Last name *</label>
          <input id="lastName" class="form-control" formControlName="lastName" autocomplete="family-name" />
        </div>
      </div>

      <div class="form-group">
        <label for="emailAddress">Email address *</label>
        <input id="emailAddress" type="email" class="form-control" formControlName="emailAddress" autocomplete="email" />
      </div>

      <div class="form-row">
        <div class="form-group">
          <label for="password">Password *</label>
          <div class="password-wrapper">
            <input id="password" [type]="showPassword ? 'text' : 'password'" class="form-control" formControlName="password" autocomplete="new-password" />
            <button type="button" class="toggle-password" (click)="togglePasswordVisibility()" [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'">Show</button>
          </div>
        </div>
        <div class="form-group">
          <label for="confirmPassword">Confirm password *</label>
          <div class="password-wrapper">
            <input id="confirmPassword" [type]="showConfirmPassword ? 'text' : 'password'" class="form-control" formControlName="confirmPassword" autocomplete="new-password" />
            <button type="button" class="toggle-password" (click)="toggleConfirmPasswordVisibility()" [attr.aria-label]="showConfirmPassword ? 'Hide password confirmation' : 'Show password confirmation'">Show</button>
          </div>
        </div>
      </div>

      <div class="form-row">
        <div class="form-group">
          <label for="phoneNumber">Phone number *</label>
          <input id="phoneNumber" type="tel" class="form-control" formControlName="phoneNumber" autocomplete="tel" />
        </div>
        <div class="form-group">
          <label for="identityNumber">South African ID number *</label>
          <input id="identityNumber" class="form-control" formControlName="identityNumber" autocomplete="off" />
          @if (identityNumberError) {
            <div class="error">{{ identityNumberError }}</div>
          }
        </div>
      </div>

      <div class="form-group">
        <label for="address">Residential address *</label>
        <textarea id="address" class="form-control" formControlName="address" rows="3"></textarea>
      </div>

      <div class="form-row">
        <div class="form-group">
          <label for="countryId">Country *</label>
          <select id="countryId" class="form-control" formControlName="countryId" (change)="onCountryChange()">
            <option value="">Select country</option>
            @for (country of countries; track country.id) {
              <option [value]="country.id">{{ country.name }}</option>
            }
          </select>
        </div>
        <div class="form-group">
          <label for="institutionId">Institution *</label>
          <select id="institutionId" class="form-control" formControlName="institutionId" (change)="onInstitutionChange()">
            <option value="">Select institution</option>
            @for (institution of institutions; track institution.id) {
              <option [value]="institution.id">{{ institution.name }}</option>
            }
          </select>
        </div>
      </div>

      <div class="form-group">
        <label for="courseId">Course of study *</label>
        <select id="courseId" class="form-control" formControlName="courseId">
          <option value="">Select course</option>
          @for (course of courses; track course.id) {
            <option [value]="course.id">{{ course.name }}</option>
          }
        </select>
      </div>

      @if (errorMessage) {
        <div class="alert alert-error" role="alert">{{ errorMessage }}</div>
      }

      <button type="submit" class="btn btn-primary submit-button" [disabled]="registrationForm.invalid || isSubmitting">
        @if (isSubmitting) { <span>Creating account...</span> } @else { <span>Create account</span> }
      </button>
    </form>

    <p class="registration-footer">Already registered? <a routerLink="/auth/login" [queryParams]="{ returnUrl: returnUrl }">Sign in</a></p>
  </section>
</main>
